<wizard-labeled-field label="Max Attendees" [size]="fieldSize">
    <wizard-tooltip>
        Limit the number of attendees that can join this event. Once the limit has been reached, new attendees will be
        prevented from signing up.
        <a href="https://faq.calendarhero.com/article/242-max-attendees" target="_blank">Learn More</a>
    </wizard-tooltip>
    <div class="grouped fields">
        <div class="inline field">
            <div class="ui radio checkbox">
                <input
                    type="radio"
                    name="maxAttendees"
                    [checked]="maxAttendees === undefined"
                    (click)="handleToggleMaxAttendees(false)"
                />
                <label>No Limit</label>
            </div>
        </div>
        <div class="inline fields no-bottom-margin">
            <div class="inline field">
                <div class="ui radio checkbox max-attendees-limit">
                    <input
                        type="radio"
                        name="maxAttendees"
                        [checked]="maxAttendees !== undefined"
                        (click)="handleToggleMaxAttendees(true)"
                    />
                    <label>Limit to: </label>
                </div>
            </div>
            <div class="inline field no-bottom-margin" [ngClass]="{ disabled: maxAttendees === undefined }">
                <input
                    class="ui input"
                    type="number"
                    min="1"
                    max="1000"
                    [ngModel]="maxAttendees"
                    (ngModelChange)="updateMaxAttendees($event)"
                />
            </div>
        </div>
    </div>
</wizard-labeled-field>
